export enum MarkerIconSvg {
  airport = 'cdn/icons/airport.svg',
  airportSelected = 'cdn/icons/airportSelected.svg',
  hotel = 'cdn/icons/hotel.svg',
  hotelLocationSelected = 'cdn/icons/hotelLocationSelected.svg',
  hotelLocation = 'cdn/icons/hotelLocation.svg',
  hotelSelected = 'cdn/icons/hotelSelected.svg',
  hotelNegarates = 'cdn/icons/hotelNegarates.svg',
  hotelNegaratesSelected = 'cdn/icons/hotelNegaratesSelected.svg',
  hotelGeniusRate = 'cdn/icons/hotelGeniusRate.svg',
  hotelGeniusRateSelected = 'cdn/icons/hotelGeniusRateSelected.svg',
  railway = 'cdn/icons/railway.svg',
  railwaySelected = 'cdn/icons/railwaySelected.svg',
  transfer = 'cdn/icons/transfer.svg',
  transferSelected = 'cdn/icons/transferSelected.svg',
  port = 'cdn/icons/port.svg',
  portSelected = 'cdn/icons/portSelected.svg',
  destination = 'cdn/icons/destination.svg',
  destinationSelected = 'cdn/icons/destinationSelected.svg',
  favorite = 'cdn/icons/favorite.svg',
  favoriteSelected = 'cdn/icons/favoriteSelected.svg',
  routeUnd = 'cdn/icons/routeUnd.svg',
  dropDown = 'cdn/icons/dropDown.svg',
  pickUp = 'cdn/icons/pickUp.svg',
  markerCluster = 'cdn/icons/markerCluster.svg',
  startIconStatic = 'cdn/icons/iconStaticStart.png',
  endIconStatic = 'cdn/icons/iconStaticEnd.png',
  hotelLocationStatic = 'cdn/icons/hotelLocation.png',
  drawCircle = 'cdn/icons/centerCircle.svg',
}
